//ブックコピー画面
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { addBook } from '../redux/bookDbSlice';
import { addSheet } from '../redux/sheetDbSlice';
import { addSheetInformation } from '../redux/sheetInformationDbSlice';
import { addCard } from '../redux/cardDbSlice';
import { addCardAttribute } from '../redux/cardAttributeDbSlice';
import { addCardShape } from '../redux/cardShapeDbSlice';
import { addMemoCardContent } from '../redux/memoCardContentDbSlice';
import { addUiCardItem } from '../redux/uiCardItemDbSlice';
import { addDrawCardContent } from '../redux/drawCardContentDbSlice';
import { addArrow } from '../redux/arrowDbSlice';
import { addRelationUserBook } from '../redux/relationUserBookDbSlice';
import { addRelationFolderBook } from '../redux/relationFolderBookDbSlice';
import { addSheetTree } from '../redux/sheetTreeDbSlice';
import useCopyBook from '../hooks/useCopyBook';
import useOneBookDb from '../hooks/useOneBookDb';

const BookNameTextField = styled(TextField)`
  width: 100%;
`;

type CopyBookDialogProps = {
  open: boolean;
  onClose: () => void;
  bookId: string;
  transitionStart: (id: string) => void;
}
const CopyBookDialog: React.FC<CopyBookDialogProps> = ({ open, onClose, bookId, transitionStart }) => {
  const dispatch = useDispatch();
  const book = useOneBookDb(bookId);
  const [value, setValue] = useState('');
  const copiedTree = useCopyBook(bookId);

  useEffect(() => {
    if (book) setValue(book.name + 'のコピー');
  }, [book])

  const copyBookExe = () => {
    if (book) {
      if (copiedTree) {
        const newBook = copiedTree.book;
        const newRelationUserBook = copiedTree.relationUserBook;
        const newRelationFolderBook = copiedTree.relationFolderBook;
        const newSheets = copiedTree.sheets;
        const newSheetInformation = copiedTree.sheetInformations;
        const newSheetTrees = copiedTree.sheetTrees;
        const newCards = copiedTree.cards;
        const newCardAttributes = copiedTree.cardAttributes;
        const newCardShapes = copiedTree.cardShapes;
        const newMemoContents = copiedTree.memoContents;
        const newUiItems = copiedTree.uiItems;
        const newDrawContents = copiedTree.drawContents;
        const newArrows = copiedTree.arrows;

        dispatch(addBook({...newBook, name: value}));
        dispatch(addRelationUserBook(newRelationUserBook));
        dispatch(addRelationFolderBook(newRelationFolderBook));
        newSheets.forEach(sheet => dispatch(addSheet(sheet)));
        newSheetInformation.forEach(sheetInformation => dispatch(addSheetInformation(sheetInformation)));
        newSheetTrees.forEach(sheetTree => dispatch(addSheetTree(sheetTree)));
        newCards.forEach(card => dispatch(addCard(card)));
        newCardAttributes.forEach(cardAttribute => dispatch(addCardAttribute(cardAttribute)));
        newCardShapes.forEach(cardShape => dispatch(addCardShape(cardShape)));
        newMemoContents.forEach(memoContent => dispatch(addMemoCardContent(memoContent)));
        newUiItems.forEach(uiItem => dispatch(addUiCardItem(uiItem)));
        newDrawContents.forEach(drawContent => dispatch(addDrawCardContent(drawContent)));
        newArrows.forEach(arrow => dispatch(addArrow(arrow)));

        if (newBook.id) transitionStart(newBook.id);
      }
      onClose();
    }
  }

  return (
    <Dialog open={open} onClose={onClose}  maxWidth="xs" fullWidth>
      <DialogTitle>このブックを複製します</DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        <BookNameTextField label="複製後のブックの名前" variant="outlined" defaultValue={value} 
                            onChange={(e) => setValue(e.target.value)}/>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={() => copyBookExe()}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CopyBookDialog;
